import React from 'react';

import { StatusChip } from '@occc-app/design-system';

import { parseDate } from '../lib/date';

export type DeprecatedStatusBadgeParams = (
  publishAt: string | null | undefined,
  expireAt: string | null | undefined,
  isArchived?: boolean,
) => React.ReactNode;

// This component is a duplicate of apps/command-center/src/lib/publicationStatusBadge.tsx.
// We need to keep this component because it is used in a table that relies on the old API, which doesn't have the publicationStatus
export const deprecatedStatusBadge: DeprecatedStatusBadgeParams = (
  publishAt,
  expireAt,
  isArchived = false,
) => {
  const now = new Date();
  const publishDate = parseDate(publishAt || now).valueOf();
  const expireDate = parseDate(expireAt || now).valueOf();
  const nowDate = now.valueOf();

  const isExpired = expireDate < nowDate;
  const isUnpublished = (!publishAt && !expireAt) || publishDate > nowDate;

  if (isExpired) {
    return <StatusChip label='Expired' variant='error' />;
  }

  if (isUnpublished) {
    return <StatusChip label='Unpublished' variant='warning' />;
  }

  if (isArchived) {
    return <StatusChip label='Archived' variant='error' />;
  }

  return <StatusChip label='Published' variant='success' />;
};
